import React, { Component, Suspense } from 'react';
import { Redirect, Route, Switch } from "react-router-dom";
import routes from "../../routes";
import './defaultPage.scss';
import { ToastContainer, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/*-- Import required components --*/
import { get, post } from "../../utility/apiClient";
import { responsiveScreenSizesEnum } from '../../utility/enums';
import MessageBox from '../../components/common/messageBox/MessageBox';
import PopupBox from '../../components/common/popupBox/PopupBox';
import LoadingScreen from '../../components/loadingScreen/LoadingScreen';
import DefaultHeader from '../../components/defaultHeader/DefaultHeader';
import Footer from '../../components/footer/Footer';
import SessionTimeOutHandler from '../../components/sessionTimeOutHandler/SessionTimeOutHandler';
import NotificationHub from '../../components/notificationHub/NotificationHub';
import NotificationBox from '../../components/common/notificationBox/NotificationBox';
import ProductMagnifier from '../../components/productMagnifier/ProductMagnifier';
import AgeGate from '../../components/common/ageGate/AgeGate';
import { getInitialDataCollection } from '../../utility/commonFunctions';
import NexusReminderNotificationBox from '../../components/V2_0/nexusReminderNotificationBox/NexusReminderNotificationBox';

/*-- Imports for redux --*/
import { connect } from 'react-redux';
import { showMessageBox } from '../../redux/actions/messageBoxActions';
import { showPopupBox } from '../../redux/actions/popupBoxActions';
import { updateResponsive, resetResponsive } from '../../redux/actions/responsiveActions';
import { showLoadingScreen, hideLoadingScreen } from '../../redux/actions/loadingScreenActions';
import { updateInsideNotificationStripe } from '../../redux/actions/notificationStripeActions';
import PreferenceModal from '../../components/preferenceModal/PreferenceModal';
import { addWebDataCollection } from '../../redux/actions/webDataCollectionActions';
import { addPromotionItems } from '../../redux/actions/promotionItemsActions';
import { addUserDetail } from '../../redux/actions/userDetailsActions';
import { addPreference } from '../../redux/actions/preferenceActions';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        loadingScreenVisible: state.loadingScreen,
        userDetails: state.userDetails,
        shoppingPreference: state.shoppingPreference,
        webDataCollection: state.webDataCollection,
        promotionItems: state.promotionItems,
        insideNotificationStripe: state.insideNotificationStripe,
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {
    showMessageBox,
    updateResponsive,
    resetResponsive,
    showLoadingScreen,
    hideLoadingScreen,
    addWebDataCollection,
    addPromotionItems,
    showPopupBox,
    updateInsideNotificationStripe,
    addUserDetail,
    addPreference
};

/**
 * Date     :   2020-06-14
 * Author   :   Dinushka Rukshan
 * Remarks  :   This page use as a default layout to route other pages
 */
class DefaultPage extends Component {
    constructor(props) {
        super(props)
        this.responsive = this.responsive.bind(this);

        this.state = {
            loadWebDataCollection: false,
            isIgnoreSessionWarning: false,
        }
    }

    componentDidMount() {
        this.responsive();
        window.addEventListener('resize', this.responsive);

        //Commented By D.Rukshan on 2024-07-26 (To Fix SEO URL redirection issue)
        // if (this.props.userDetails && this.props.userDetails.customerID !== 0 && this.props.shoppingPreference.outletCode !== "") {
        //     this.getInitialDataCollection();
        //     this.getInsideNotificationStripe();
        // }
        // else {            
        //     this.showWelcomePage();
        // }

        //Added by D.Rukshan on 2024-07-26 (To Fix SEO URL redirection issue)
        if (this.props.userDetails && (this.props.userDetails.customerID === 0 || this.props.userDetails.customerID === null)) {
            this.showWelcomePage();
        } else {
            this.getInitialDataCollection();
            this.getInsideNotificationStripe();
        }
    };

    showWelcomePage() {
        this.props.showLoadingScreen();
        get(`/Common/GetSystemConfiguration`).then(response => {
            if (response.data.statusCode === 200) {
                if (response.data.result != null) {
                    if (response.data.result.isShowWelcomePage) {
                        window.location.href = "/welcome";
                    } else {
                        this.guestLogin();
                    }
                } else {
                    let messageBox = {
                        show: true,
                        title: "Oops!",
                        className: "error",
                        content: response.data.errorList[0].statusMessage,
                        isConfirmation: false,
                        callBackFunction: null
                    }
                    this.props.showMessageBox(messageBox);
                }
            }
            else {
                let messageBox = {
                    show: true,
                    title: "Oops!",
                    className: "error",
                    content: response.data.errorList[0].statusMessage,
                    isConfirmation: false,
                    callBackFunction: null
                }
                this.props.showMessageBox(messageBox);
            }
            this.props.hideLoadingScreen();
        })
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.responsive);
    };

    responsive() {
        if (window.innerWidth <= responsiveScreenSizesEnum.mobileSmallScreen) {
            let screen = { isTabScreen: false, isMobileLargeScreen: false, isMobileSmallScreen: true }
            this.props.updateResponsive(screen);
        } else if (window.innerWidth <= responsiveScreenSizesEnum.mobileLargeScreen) {
            let screen = { isTabScreen: false, isMobileLargeScreen: true, isMobileSmallScreen: false }
            this.props.updateResponsive(screen);
        } else if (window.innerWidth <= responsiveScreenSizesEnum.tabScreenSize) {
            let screen = { isTabScreen: true, isMobileLargeScreen: false, isMobileSmallScreen: false }
            this.props.updateResponsive(screen);
        } else {
            this.props.resetResponsive();
        }
    };

    guestLogin() {        
        this.props.showLoadingScreen();
        post(`/Login/GuestLogin`).then(response => {
            if (response.data.statusCode === 200 && response.data.result.customerID > 0) {
                this.props.addUserDetail(response.data.result).then(() => {
                    let data = {
                        outletCode: response.data.result.preferredOutlet,
                        outletName: response.data.result.preferredOutletDescription,
                        shoppingMethod: "Delivery",
                        suburbID: 0
                    }
                    this.props.addPreference(data).then(() => {                        
                        this.getInitialDataCollection();
                        this.getInsideNotificationStripe();
                    })
                })
            } else {
                let messageBox = {
                    show: true,
                    title: "Oops!",
                    className: "error",
                    content: response.data.errorList[0].statusMessage,
                    isConfirmation: false,
                    callBackFunction: null
                }
                this.props.showMessageBox(messageBox);
            }
            this.props.hideLoadingScreen();
        })
    }

    getInitialDataCollection() {        
        if (this.props.webDataCollection.bannerList === null || this.props.webDataCollection.bannerList.length === 0) {
            getInitialDataCollection(() => { this.setState({ loadWebDataCollection: true }) });
        } else {
            this.setState({ loadWebDataCollection: true })
        }
    };

    getInsideNotificationStripe() {
        //prevent always calling the endpoint
        if (!this.props.insideNotificationStripe.triggered) {
            this.props.showLoadingScreen();
            get(`/Notification/GetInsideNotificationStripe`).then(response => {
                if (response.data.statusCode === 200) {
                    if (response.data.result) {
                        let body = {
                            message: response.data.result.message,
                            cssClass: response.data.result.cssClass,
                            isActive: response.data.result.message ? true : false,
                            triggered: true
                        }
                        this.props.updateInsideNotificationStripe(body);
                    }
                }
                else {
                    let messageBox = {
                        show: true,
                        title: "Oops!",
                        className: "error",
                        content: response.data.errorList[0].statusMessage,
                        isConfirmation: false,
                        callBackFunction: null
                    }
                    this.props.showMessageBox(messageBox);
                }
                this.props.hideLoadingScreen();
            })
        }
    }

    loading = () => (
        <LoadingScreen isVisible={true} />
    );

    render() {
        if (this.state.loadWebDataCollection === false) {
            return (<div>
                <LoadingScreen isVisible={true} />
            </div>);
        } else {
            return (
                <div style={{ overflow: "hidden" }}>
                    <DefaultHeader />
                    <div className={this.props.insideNotificationStripe.isActive ? "main-content-holder-stripe" : "main-content-holder"}>
                        <Suspense fallback={this.loading()}>
                            <Switch>
                                {routes.map((route, idx) => {
                                    return route.component ? (
                                        <Route
                                            key={idx}
                                            path={route.path}
                                            exact={route.exact}
                                            name={route.name}
                                            render={props => (
                                                <route.component {...props} />
                                            )} />
                                    ) : (null);
                                })}
                                <Redirect from="/" to="/welcome" />
                            </Switch>
                        </Suspense>
                    </div>
                    <Footer />
                    <MessageBox />
                    <PopupBox />
                    <LoadingScreen isVisible={this.props.loadingScreenVisible} />
                    <ToastContainer position="top-right" autoClose={1500} hideProgressBar newestOnTop closeOnClick rtl={false}
                        pauseOnVisibilityChange draggable pauseOnHover={false} transition={Flip} />
                    <SessionTimeOutHandler />
                    <NexusReminderNotificationBox />
                    <NotificationBox />
                    <NotificationHub />
                    <ProductMagnifier />
                    <AgeGate />
                    <PreferenceModal />
                </div>
            )
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
